import type { StreamProvider } from '@vgtv/api-client';
import { Category, ConsentManager } from '@vgtv/consent-manager';
import { countryMap } from '../countryMap';

const getAllowlist = (provider: StreamProvider): Category[] => {
  const providerCountry = Object.keys(countryMap).find((k) =>
    countryMap[k].includes(provider)
  );

  if (providerCountry === 'no') {
    return ['CMP:advertising', 'CMP:personalisation'];
  }

  return ['CMP:advertising'];
};

export const getConsentManager = (provider: StreamProvider) => {
  return new ConsentManager({ allowlist: getAllowlist(provider) });
};
